import {combineReducers} from 'redux';

import systemReducer from './system.reducer';

export default combineReducers({
    system: systemReducer,
});
